import { create } from 'zustand';

import { WebformPage } from '@/lib/enums';

export interface WebformState {
  webformToDisplay: any;
  setWebformToDisplay: (webformToDisplay: any) => void;
  showWebform: boolean;
  setShowWebform: (showWebform: boolean) => void;
  webformPage: WebformPage;
  setWebformPage: (webformPage: WebformPage) => void;
  showErrorToast: boolean;
  setShowErrorToast: (showErrorToast: boolean) => void;
  requestId: string;
  setRequestId: (requestId: string) => void;
}

export const useWebformStore = create<WebformState>()(set => ({
  webformToDisplay: {},
  setWebformToDisplay: webformToDisplay => set({ webformToDisplay }),
  showWebform: false,
  setShowWebform: showWebform => set({ showWebform }),
  webformPage: WebformPage.FormDetails,
  setWebformPage: webformPage => set({ webformPage }),
  showErrorToast: false,
  setShowErrorToast: showErrorToast => set({ showErrorToast }),
  requestId: '',
  setRequestId: requestId => set({ requestId }),
}));
